import Vue from 'vue'
import BzbsApi from '@/core/Http/BzbsApi.js'
import Cache from '@/helper/Cache.js'
import Account from '@/helper/AccountHelper.js'

/**
 * @method getCards
 * @method createDigitalCard
 * @method createPhysicalCard
 * @method deleteCard
 * @method cardHistory
 * @method cardTopup
 */
export default {
  config: function () {
    return Vue.bzbsConfig
  },
  token: function () {
    return Account.getCacheToken() ? Account.getCacheToken() : null
  },
  ewallet_token: function () {
    return Account.getCacheWalletToken() ? Account.getCacheWalletToken() : null
  },
  app_id: function () {
    if (Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')) != null) {
      if (
        Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).appId !=
        undefined
      ) {
        return Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).appId
      } else {
        return Account.getCacheCustom('app_id')
      }
    } else {
      return Account.getCacheCustom('app_id')
    }
  },
  agency_id: function () {
    return Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).sponsorId
  },
  locale: function () {
    return Cache.get('BzbsUser_' + Account.getCacheCustom('app_id')).locale
  },
  getCards: function () {
    var strUrl = this.config().bzbModuleUrl + '/crmpluscustomer/cards'
    return BzbsApi.connectBzbsGet(strUrl, this.token(), null)
  },
  createDigitalCard: function () {
    var strUrl = this.config().bzbModuleUrl + '/crmpluscustomer/digital_card'
    return BzbsApi.connectBzbsPost(strUrl, this.token(), {})
  },
  createPhysicalCard: function (params) {
    var strUrl = this.config().bzbModuleUrl + '/crmpluscustomer/physical_card'
    return BzbsApi.connectBzbsPost(strUrl, this.token(), params)
  },
  deleteCard: function (id) {
    var params = {
      cardId: id,
    }
    var strUrl = this.config().bzbModuleUrl + '/crmpluscustomer/card'
    return BzbsApi.connectBzbsDelete(strUrl, this.token(), params)
  },
  cardHistory: function (params) {
    var strUrl = this.config().bzbsCashcardUrl + '/card/history'
    return BzbsApi.connectBzbsGet(strUrl, this.ewallet_token(), params)
  },
  cardTopup: function (params) {
    var strUrl = this.config().bzbsCashcardUrl + '/card/topup'
    return BzbsApi.connectBzbsPost(strUrl, this.ewallet_token(), params)
  },
  genQr: function (params) {
    var strUrl = this.config().bzbsCashcardUrl + '/qr'
    return BzbsApi.connectBzbsPost(strUrl, this.ewallet_token(), params)
  },
}
